module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#sort",
      toString: function () {
        return this.url;
      }
    }